module.exports = __webpack_public_path__ + "img/4-3.7ac431ce.png";